<template>
  <div class="isef-mobile" ref="isefButton">
    <button class="isef-mobile-button"
            :class="{'isef-mobile-button-sticky' : isSticky || toggleMenu}"
            @click.prevent="() => {
              checkButtonPos()
              toggleCatMenu()
            }">
      Choose A Category <i class="fa-regular"
                           :class="{'fa-angle-up' : this.toggleMenu, 'fa-angle-down' : !this.toggleMenu}" />
    </button>
    <ul v-if="toggleMenu"
        class="isef-mobile-menu">
      <router-link to="/home"
                   :class="{'is-inactive' : !isHome}">
        <li class="isef-mobile-menu-item">
          <img class="isef-mobile-menu-icon"
               :class="{'is-active' : isHome}"
               src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fcategories%2FAll%20Categories.png?alt=media&token=772a4ae1-cf08-475a-91fc-9227f2a8a197" alt="All Categories" />
            <span class="isef-mobile-menu-text">All Categories</span>
        </li>
      </router-link>
      <li v-for="category in categories"
          :key="category.id"
          class="isef-mobile-menu-item"
          :class="{'is-inactive': selectedCategoryID !== category.id && category.id !== parentCategoryID && category.id !== grandparentCategoryID}"
          @click.prevent="select(category)">
        <img :src="category.image"
             :alt="category.name"
             class="isef-mobile-menu-icon"
             :class="{'is-active': selectedCategoryID === category.id || category.id === parentCategoryID || category.id === grandparentCategoryID}"/>
        <span>{{category.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import utmTracking from '@/mixins/utm-tracking'

export default {
  props: ['selectedCategoryID', 'userCategories', 'showSponsor'],
  mixins: [componentState, utmTracking],
  data: function () {
    return {
      position: 0,
      toggleMenu: false,
      isSticky: false,
      inViewport: true
    }
  },
  watch: {
    categories: function () {
      this.$nextTick(() => this.checkIfInViewport())
    },
    scrollLeft: function () {
      this.checkIfInViewport()
    },
    selectedCategoryID: function () {
      if (this.selectedCategoryID > 0) {
        this.scrollToCategory()
      }
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted: function () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    isHome: function () {
      return this.$route.name === 'home'
    },
    subEventParam: function () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return this.$route.path.substring(1)
    },
    categories: function () {
      // do not show private categories in category explore row
      let categories = this.$store.getters.categoriesLoaded ? this.$store.getters.projectCategories : []
      if (categories.length > 0) {
        categories = categories.filter(category => !category.isPrivate)
      }
      return categories
    },
    parentCategoryID: function () {
      return this.selectedCategoryID > 0 ? this.$store.getters.categoryByID(this.selectedCategoryID).parentID || this.selectedCategoryID : 0
    },
    grandparentCategoryID: function () {
      return this.parentCategoryID > 0 ? this.$store.getters.categoryByID(this.parentCategoryID).parentID || this.parentCategoryID : 0
    },
    userCategoriesIDs: function () {
      const userCatIDs = []
      if (this.userCategories) {
        for (let i = 0; i < this.userCategories.length; i++) {
          userCatIDs.push(this.userCategories[i].id)
        }
      }
      return userCatIDs
    }
  },
  methods: {
    checkButtonPos: function () {
      if (this.position < 165) {
        window.scrollTo({ top: 165, behavior: 'smooth' })
        this.position = 165
      }
    },
    toggleCatMenu: function () {
      if (this.position <= 165) {
        setTimeout(() => {
          this.toggleMenu = !this.toggleMenu
        }, 1000)
      } else {
        this.toggleMenu = !this.toggleMenu
      }
    },
    handleScroll: function () {
      this.position = window.scrollY
      this.isSticky = this.position >= 165
    },
    select: function (category) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'trackCategory',
          CategoryID: category.id,
          CategoryName: category.slug
        })
      }
      if (category.id === this.selectedCategoryID) {
        this.$router.push({
          name: 'home',
          query: { r: this.refreshKey() }
        })
      } else if (category.subCategories) {
        if (this.$route.params.category === category.slug) {
          this.$emit('viewCategory', category.name)
        } else {
          this.$router.push({ name: 'projectsCategory', params: { category: category.slug } })
        }
      } else {
        this.$router.push({ name: 'viewAll', query: { category: category.slug, page: this.subEventParam } })
      }
      this.toggleMenu = false
      this.selectedCategoryID = category.id
    },
    checkIfInViewport: function () {
      if (this.$refs.categories && this.$refs.categories.children.length > 0) {
        const bounding = this.$refs.categories.children[this.categories.length - 1].getBoundingClientRect()
        const rightSide = Math.min(document.documentElement.clientWidth, window.innerWidth)
        if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= rightSide && bounding.bottom <= rightSide) {
          this.inViewport = true
        } else {
          this.inViewport = false
        }
      }
    },
    checkCategoryPreference: function (category) {
      const catOrSubCat = category.subCategories || [category.id]
      const matches = this.userCategoriesIDs.filter(cat => catOrSubCat.includes(cat))
      return matches.length > 0
    },
    scrollToCategory: function () {
      setTimeout(() => {
        let selectedCat = document.querySelector('ul.categories > .category-container:not(.is-inactive)')
        if (selectedCat) {
          if (selectedCat.nextSibling) {
            selectedCat = selectedCat.nextSibling
          }
          selectedCat.scrollIntoView({
            behavior: 'smooth'
          })
        } else {
          // if failed to get selectedCategory, just scroll to top
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.isef-mobile {
  position: relative;
  display: none;
  width: 100%;
  margin-top: -1rem;
  @media only screen and (max-width: 550px) {
    display: inline-flex;
  }
  &-button {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 24px;
    gap: 10px;
    background: rgba(255, 255, 255, 0.12);
    border: none;
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
    color: #FFFFFF;
    cursor: pointer;
    &-sticky {
      position: fixed;
      top: 3rem;
      z-index: 10;
      background:#1D1B43;
    }
  }
  &-menu {
    position: fixed;
    width: 100%;
    height: calc(100% - 95px);
    top: 5.7rem;
    background-color: #040233;
    z-index: 10;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    padding-bottom: 6rem;
    &-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 1rem;
      cursor: pointer;
    }
    &-icon {
      width: 60px;
      height: 60px;
      margin-right: 1rem;
      border-radius: 50%;
    }
    &-text {
      font-family: 'Helvetica Neue';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #FFFFFF;
    }
  }
}

.is-inactive{
  opacity: 0.5;
}

.is-active {
  background: linear-gradient(132.76deg, #3E82B4 19.3%, #CC4B79 36.86%, #DF8E44 59.91%, #FFD563 80.24%);
}
</style>
